<template>
	<!-- 刷新按钮 -->
	<div class="flex-row-center-start pl-20 h-36 pointer" @click="Operate">
		<img class="wh-20" src="@/assets/icon_17.png" alt="">
		<span class="fz-14 color-primary ml-8">{{ translate.ShowText('刷新') }}</span>
	</div>
</template>

<script lang="ts" setup>
import translate from '@/api/translate';
const emits = defineEmits(["change"]);

const Operate = () => {
	emits("change");
};
</script>

<style></style>